export const GET_LOCALIZATIONS = 'GET_LOCALIZATIONS';
export const GET_LOCALIZATION_BY_ID = 'GET_LOCALIZATION_BY_ID';
export const UPDATE_LOCALIZATION = 'UPDATE_LOCALIZATION';
export const DELETE_LOCALIZATION = 'DELETE_LOCALIZATION';
export const CREATE_LOCALIZATION = 'CREATE_LOCALIZATION';
